import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function AccountDeletion() {
  return (
    <main className="min-h-screen bg-neutral-50 px-5 py-10 text-neutral-900 md:px-8">
      <article className="mx-auto max-w-2xl rounded-3xl border border-neutral-200 bg-white p-6 shadow-sm md:p-10">
        <Link to="/" className="text-sm font-semibold text-blue-600">
          ← Voltar ao Talki
        </Link>
        <h1 className="mt-6 text-3xl font-extrabold tracking-[-0.03em]">Excluir conta e dados</h1>
        <p className="mt-4 text-[15px] leading-7 text-neutral-700">
          Para solicitar a exclusão da sua conta Talki, envie um e-mail usando o mesmo endereço cadastrado na conta.
          Use o assunto <strong>Excluir minha conta Talki</strong>.
        </p>
        <Button asChild className="mt-6">
          <a href="mailto:influency.agency.real@gmail.com?subject=Excluir%20minha%20conta%20Talki">
            Solicitar exclusão por e-mail
          </a>
        </Button>
        <div className="mt-8 space-y-3 text-[15px] leading-7 text-neutral-700">
          <p>Podemos pedir uma confirmação para proteger a conta contra solicitações não autorizadas.</p>
          <p>
            Após a validação, excluiremos a conta, o histórico de prática, as transcrições e os dados de progresso
            associados, salvo o que precisar ser mantido por obrigação legal, prevenção de fraude ou resolução de disputas.
          </p>
          <p>
            Se você quiser apagar apenas dados específicos sem encerrar a conta, descreva isso na mensagem para que a
            solicitação seja analisada separadamente.
          </p>
        </div>
        <p className="mt-8 text-sm text-neutral-500">
          Contato: <a className="font-semibold text-blue-600" href="mailto:influency.agency.real@gmail.com">influency.agency.real@gmail.com</a>
        </p>
      </article>
    </main>
  );
}
